<script setup>
import { ref } from 'vue'
import The_Header from "./components/The_Header.vue";
import The_Footer from "./components/The_Footer.vue";
//----------------------------------------------------
import home from "./components/home.vue";
import contactus from "./components/contactus.vue";
import products from "./components/products.vue";
import services from "./components/services.vue";
import VascularProducts from "./components/VascularProducts.vue";
import Angiography from "./components/Angiography.vue";
import Urology from "./components/Urology.vue";
import Oncology from "./components/Oncology.vue";
import HospitalProducts from "./components/HospitalProducts.vue";
import SpecializedHospital from "./components/SpecializedHospital.vue";
import generalsurgery from "./components/generalsurgery.vue";
import cosmetics from "./components/cosmetics.vue";
import ophtalmology from "./components/ophtalmology.vue";

const tabs = {
  home,
  contactus,
  products,
  services,
  VascularProducts,
  Angiography,
  Urology,
  Oncology,
  HospitalProducts,
  SpecializedHospital,
  generalsurgery,
  cosmetics,
  ophtalmology
}

let currentTab = ref("home");

function change_component(name) {
  currentTab.value = name;
}
</script>

<template>
  <div>
      <The_Header @change_component="change_component"/>
      <component :is="tabs[currentTab]" @change_component="change_component"></component>
      <The_Footer/>
  </div>
</template>

<style scoped></style>
